// extracted by mini-css-extract-plugin
module.exports = {"recommend":"recommend_recommend__1K41E","text":"recommend_text__38v3B","content":"recommend_content__2w6Bq","logo":"recommend_logo__2ksbr","logoImg":"recommend_logoImg__3nTJK"};